import config from "appConfig";

const RESULT_CACHES = {};
const FETCHING = {};
export const CACHE_KEY_SEPARATOR = "@@";

const updateCachedResult = (api: string, data: any, hasTimeout?: boolean) => {
  if (hasTimeout && data) {
    setTimeout(() => {
      RESULT_CACHES[api] = undefined;
    }, config.apiCacheTimeout);
  }

  RESULT_CACHES[api] = data;
  FETCHING[api] = undefined;
};

const fetching = (api: string, callback: Function, hasTimeout?: boolean) => {
  FETCHING[api] = callback().then((result: any) => {
    updateCachedResult(api, result, hasTimeout);
    return result;
  });
};

export const getCachedResult = (
  api: string,
  callback: Function,
  hasTimeout: boolean
) => {
  const deferredFetching = FETCHING[api];

  if (typeof RESULT_CACHES[api] === "undefined" && !deferredFetching) {
    fetching(api, callback, hasTimeout);
    return FETCHING[api];
  }

  if (deferredFetching) {
    return deferredFetching;
  }

  return Promise.resolve(RESULT_CACHES[api]);
};

const isValidApi = (api: string, apiCacheKeys: any) => {
  if (api.includes(CACHE_KEY_SEPARATOR)) {
    const apiParts = api.split(CACHE_KEY_SEPARATOR);

    return apiCacheKeys.includes(parseInt(apiParts[1], 10));
  }

  return false;
};

export const removeCache = (apiCacheKeys: any) => {
  Object.keys(RESULT_CACHES).forEach(key => {
    if (isValidApi(key, apiCacheKeys)) {
      updateCachedResult(key, undefined);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/apiCache.ts